export default __webpack_public_path__ + "54e6f365d7db36327e980f7449cf8b6b.svg";